import React from 'react';
import { Card, CardContent } from '../Card';
import { Send } from 'lucide-react';
import { useLeadForm } from '../LeadFormContext';
const products = [{
  name: 'Kubota A211N',
  hp: '21 л.с.',
  price: '7 178 050 ₸',
  badge: 'NeoStar',
  badgeColor: 'bg-blue-100 text-blue-700',
  cabinNote: 'Возможна комплектация без кабины',
  image: 'https://cdn.magicpatterns.com/uploads/6rn2pv8hCe51emCRb3N54Q/21-1.jpg'
}, {
  name: 'Kubota B2441',
  hp: '24 л.с.',
  price: '8 250 000 ₸',
  badge: 'NeoStar',
  badgeColor: 'bg-blue-100 text-blue-700',
  cabinNote: 'Возможна комплектация без кабины',
  image: 'https://cdn.magicpatterns.com/uploads/giZccNAWzLuS5HRi4vPa2j/24.jpg'
}, {
  name: 'Kubota L3408',
  hp: '35 л.с.',
  price: '12 446 500 ₸',
  badge: 'Серия L',
  badgeColor: 'bg-orange-100 text-orange-700',
  cabinNote: 'Возможна комплектация с кабиной',
  image: 'https://cdn.magicpatterns.com/uploads/t7apzDaihj5cyfKKDbjc4n/35.jpg'
}, {
  name: 'Kubota L4508',
  hp: '45 л.с.',
  price: '14 900 000 ₸',
  badge: 'Серия L',
  badgeColor: 'bg-orange-100 text-orange-700',
  cabinNote: 'Возможна комплектация с кабиной',
  image: 'https://cdn.magicpatterns.com/uploads/arW2Q1x7gcSF9EWzppTMJP/L45.jpg'
}, {
  name: 'Kubota MU4501',
  hp: '45 л.с.',
  price: '15 800 000 ₸',
  badge: 'Серия MU',
  badgeColor: 'bg-teal-100 text-teal-700',
  cabinNote: 'Возможна комплектация без кабины',
  image: 'https://cdn.magicpatterns.com/uploads/4Hc5TKnnRiRkovux6mEXdF/MU45.jpg'
}, {
  name: 'Kubota MU5502',
  hp: '55 л.с.',
  price: '17 732 000 ₸',
  badge: 'Серия MU',
  badgeColor: 'bg-teal-100 text-teal-700',
  cabinNote: 'Возможна комплектация без кабины',
  image: 'https://cdn.magicpatterns.com/uploads/i2UWouS1AAvWczy77VuWTo/MU55.jpg'
}, {
  name: 'Kubota M704',
  hp: '72 л.с.',
  price: '32 274 000 ₸',
  badge: 'Серия M',
  badgeColor: 'bg-purple-100 text-purple-700',
  cabinNote: 'Кабина с кондиционером в базе',
  image: 'https://cdn.magicpatterns.com/uploads/oEYB7VqnW49BVdURvpFWky/M72.jpg'
}, {
  name: 'Kubota M854',
  hp: '85 л.с.',
  price: '35 500 000 ₸',
  badge: 'Серия M',
  badgeColor: 'bg-purple-100 text-purple-700',
  cabinNote: 'Кабина с кондиционером в базе',
  image: 'https://cdn.magicpatterns.com/uploads/pRKNTvXG1AqUvs4xgaXjAQ/M85.jpg'
}, {
  name: 'Kubota M954',
  hp: '95 л.с.',
  price: '38 900 000 ₸',
  badge: 'Флагман',
  badgeColor: 'bg-red-100 text-red-700',
  cabinNote: 'Кабина с кондиционером в базе',
  image: 'https://cdn.magicpatterns.com/uploads/iRnvvooQQo2CMR4BfKASej/M95.jpg'
}];
export function ProductCards() {
  const {
    openForm
  } = useLeadForm();
  return <section className="bg-[#F5F7FA] px-5 py-14 md:px-12 lg:px-24" data-id="element-114">
      <div className="max-w-5xl mx-auto" data-id="element-115">
        <h2 className="font-heading font-bold text-[28px] md:text-[36px] text-[#0A1A3F] mb-8 text-center" data-id="element-116">
          Популярные модели
        </h2>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-5" data-id="element-117">
          {products.map(product => <Card key={product.name} className="rounded-2xl border border-gray-200 bg-white overflow-hidden" data-id="element-118">
              <CardContent className="p-0" data-id="element-119">
                {/* Product image */}
                <div className="bg-gray-50 h-32 md:h-44 flex items-center justify-center overflow-hidden" data-id="element-120">
                  <img src={product.image} alt={product.name} className="w-full h-full object-contain p-2" data-id="element-121" />
                </div>
                <div className="p-3 md:p-4" data-id="element-122">
                  <span className={`inline-block text-[10px] md:text-xs font-semibold px-2 py-0.5 rounded-full mb-2 ${product.badgeColor}`} data-id="element-123">
                    {product.badge}
                  </span>
                  <h3 className="font-heading font-bold text-sm md:text-base text-[#0A1A3F] leading-tight" data-id="element-124">
                    {product.name}
                  </h3>
                  <p className="text-xs md:text-sm text-gray-500 mt-0.5" data-id="element-125">
                    {product.hp}
                  </p>
                  <p className="text-[10px] md:text-xs text-gray-400 mt-1 italic" data-id="element-126">
                    {product.cabinNote}
                  </p>
                  <p className="font-heading font-bold text-base md:text-lg text-[#228B22] mt-2" data-id="element-127">
                    {product.price}
                  </p>
                  <button onClick={openForm} className="inline-block text-xs md:text-sm text-[#0A1A3F] font-medium underline underline-offset-2 mt-2 hover:text-[#228B22] transition-colors cursor-pointer" data-id="element-128">
                    Узнать подробнее →
                  </button>
                </div>
              </CardContent>
            </Card>)}
        </div>

        {/* Preorder offer */}
        <div className="mt-6 bg-[#FFC107]/15 border border-[#FFC107]/30 rounded-2xl px-4 py-3 text-center" data-id="element-129">
          <p className="text-sm md:text-base font-semibold text-[#0A1A3F]" data-id="element-130">
            🚚 Предзаказ = бесплатная доставка до вашего хозяйства
          </p>
        </div>

        {/* CTA */}
        <button onClick={openForm} className="flex items-center justify-center gap-2.5 w-full bg-[#25D366] hover:bg-[#1da851] text-white font-heading font-bold text-lg min-h-[56px] rounded-2xl transition-colors mt-6 cursor-pointer" data-id="element-131">
          <Send className="w-5 h-5" data-id="element-132" />
          Подобрать трактор
        </button>
      </div>
    </section>;
}